var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('ResolutionMobile',_vm._b({},'ResolutionMobile',_vm.resolutionProps,false)):_c('ResolutionDesktop',_vm._b({},'ResolutionDesktop',_vm.resolutionProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }